import { render, staticRenderFns } from "./start-stop.vue?vue&type=template&id=ce4899d4&scoped=true&"
import script from "./start-stop.js?vue&type=script&lang=js&"
export * from "./start-stop.js?vue&type=script&lang=js&"
import style0 from "./start-stop.css?vue&type=style&index=0&id=ce4899d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce4899d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
installComponents(component, {VBadge})
